// select a curriculum
export const SELECTED_CURRICULUM = 'SELECTED_CURRICULUM';

// Fetch current user Curriculum
export const FETCH_USER_CURRICULUMS_REQUEST = 'FETCH_USER_CURRICULUMS_REQUEST';
export const FETCH_USER_CURRICULUMS_SUCCESS = 'FETCH_USER_CURRICULUMS_SUCCESS';
export const FETCH_USER_CURRICULUMS_FAILED = 'FETCH_USER_CURRICULUMS_FAILED';
